import React from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import { Table } from "../view/Table";
import DeviceManagementTableRow from "./DeviceManagementTableRow";
import DeviceManagementTableRowSkeleton from "./DeviceManagementTableRowSkeleton";
import { TableContext } from "../index";

function DeviceManagementTable({ devices }) {
    const { config } = React.useContext(TableContext);

    const headers = [
        {
            name: 'HOST', width: '70%', onClick: () => {
            }
        },
        {
            name: 'ENABLE ALERTING', onClick: () => {
            }
        }
    ]

    return (
        <>
            <Table headers={headers} elements={devices} containsEditButton={false} className="mt-2">
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <DeviceManagementTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    devices.map((devices, index) => <DeviceManagementTableRow key={index} data={devices} index={index} />)
                )}
            </Table>
            {!config.isLoading && devices.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    )

}

function mapStateToProps(state) {
    debug("DeviceManagementTable mapStateToProps", state);
    const page = state.alertPage;
    return {
        devices: page.devices || []
    };
}


export default connect(mapStateToProps)(DeviceManagementTable);